import { createClassName } from 'utils/createClassName';

import './customInputStyles.scss';

export const createCustomInputClassName = createClassName('customInput');
